import { render, staticRenderFns } from "./recruit-item.vue?vue&type=template&id=19fdbaec&scoped=true"
import script from "./recruit-item.vue?vue&type=script&lang=js"
export * from "./recruit-item.vue?vue&type=script&lang=js"
import style0 from "./recruit-item.vue?vue&type=style&index=0&id=19fdbaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fdbaec",
  null
  
)

export default component.exports